import type { LucideProps } from 'lucide-react';

export const formFieldLucideIconProps: Pick<
  LucideProps,
  'size' | 'strokeWidth' | 'absoluteStrokeWidth'
> = {
  size: 20,
  strokeWidth: 2,
  absoluteStrokeWidth: true,
};

export const formFieldLucideIconColor = '#6B6B6B';

export const formFieldStartAdornmentIconProps = {
  ...formFieldLucideIconProps,
  color: formFieldLucideIconColor,
  style: { marginLeft: 4 },
} as const;
